import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Mission() {
  return <section data-section-id="253405" id="mission" className="bg-background text-foreground py-20">
      <div className="page-container flex flex-col items-center text-center max-w-4xl mx-auto">
        {}
        <div className="w-[60px] h-[2px] bg-primary mb-8" aria-hidden="true" />

        {}
        <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-8 tracking-tight text-balance">
          Nuestra misión es forjar el futuro de la industria del acero con integridad.
        </h2>

        {}
        <div className="space-y-6 mb-10">
          <p className="text-lg text-muted-foreground font-sans">
            En Kalisch Acero, creemos que la solidez de una estructura comienza con la calidad de sus materiales y la confianza en sus proveedores.
          </p>
          <p className="text-lg font-default font-semibold text-foreground">
            Nos especializamos en la distribución y procesamiento de acero para proyectos industriales y comerciales de alta exigencia.
          </p>
          <p className="text-lg text-muted-foreground font-sans">
            Nuestra promesa es garantizar la excelencia operativa en cada entrega, asegurando que su obra cuente con el respaldo de un líder en el mercado.
          </p>
          <p className="text-lg text-muted-foreground font-sans">
            Contáctenos hoy para recibir una asesoría técnica personalizada para su próximo gran proyecto.
          </p>
        </div>

        {}
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center mb-20">
          <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground w-full sm:w-64 h-12 text-base font-default rounded-md shadow-md transition-all" asChild>
            <Link to="/NosotrosPage">Conocer Más</Link>
          </Button>
          <Button variant="outline" className="border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground w-full sm:w-64 h-12 text-base font-default rounded-md shadow-md transition-all" asChild>
            <Link to="/HomePage">Contáctanos</Link>
          </Button>
        </div>

        {}
        
      </div>
    </section>;
}